"use strict";

/*
 * indicative-parser
 *
 * (c) Harminder Virk <virk@adonisjs.com>
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
*/
Object.defineProperty(exports, "__esModule", {
  value: true
});
const getLiteralType_1 = require("../utils/getLiteralType");
/**
 * Define a number
 */
exports.number = function () {
  for (var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++) {
    rules[_key] = arguments[_key];
  }
  return getLiteralType_1.getLiteralType('number', rules || [], false);
};
/**
 * Define an optional number
 */
exports.number.optional = function () {
  for (var _len2 = arguments.length, rules = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    rules[_key2] = arguments[_key2];
  }
  return getLiteralType_1.getLiteralType('number', rules || [], true);
};